/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Handle, Position } from '@xyflow/react'
import { SiMqtt } from 'react-icons/si'
import { Box } from '@chakra-ui/react'
import { marked } from 'marked'
import hljs from 'highlight.js'
import { useEffect } from 'react'

function OutputMessageNode({ data, isConnectable }) {
  useEffect(() => {
    hljs.highlightAll()
  })

  return (
    <>
      <Box className="custom-node-datahub node-output">
        <div className="node-header">
          <SiMqtt size={20} />
          <span>MQTT Output</span>
        </div>
        <div className="node-content">
          <div className="node-section">
            <div className="node-label">Topic</div>
            <div className="node-value">{data.topic}</div>
          </div>
          <div className="node-section">
            <div className="node-label">Message</div>
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
            <div dangerouslySetInnerHTML={{ __html: marked(data?.message) }} />
          </div>
        </div>
      </Box>
      <Handle type="target" position={Position.Left} />
    </>
  )
}

export default OutputMessageNode
